var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ff44f0;\r\n        opacity: .43;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #00376d;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #007292;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #51ce00;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.72,64.29h-21.43c-4.69,0-9.18,1.85-12.52,5.14-3.33,3.29-5.24,7.76-5.31,12.45.07,4.69,1.98,5.21,5.31,8.5,3.34,3.29,7.83,5.14,12.52,5.14h21.43c4.68,0,9.18-1.85,12.51-5.14,3.34-3.29,5.24-3.81,5.31-8.5-.07-4.69-1.97-9.16-5.31-12.45-3.33-3.29-7.83-5.14-12.51-5.14Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.92,85.56c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 71.92,
    cy: 71.56,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "66.33 71.98 69.78 75.43 77.52 67.69"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.86,39.29c0,3.53-1.05,6.98-3.01,9.92-1.96,2.93-4.75,5.22-8.01,6.57-3.27,1.36-6.86,1.71-10.32,1.02-3.47-.69-6.65-2.39-9.14-4.89-2.5-2.49-4.2-5.68-4.89-9.14-.69-3.46-.34-7.06,1.01-10.32,1.36-3.26,3.64-6.05,6.58-8.01,2.94-1.96,6.39-3.01,9.92-3.01,4.74,0,9.28,1.88,12.63,5.23,3.35,3.35,5.23,7.89,5.23,12.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.34,14.66C37.15-30.63-30.62,37.2,14.65,85.36c48.18,45.25,115.98-22.54,70.69-70.7ZM50,92.95C17.38,93.78-4.17,55.43,13.13,27.95,26.27,4.61,61.07-.03,79.85,19.12c27.7,25.24,7.81,75.01-29.85,73.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.46,7.55c-.76.12-1.52.26-2.27.42.75-.16,1.5-.3,2.27-.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.88,8.03c-.68.15-1.36.31-2.04.49.67-.18,1.35-.35,2.04-.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.19,7.97c-.1.02-.21.05-.31.07.1-.02.21-.05.31-.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.84,8.53c-.06.02-.11.03-.17.05.06-.02.11-.03.17-.05Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.16,12.48c-.15.08-.3.17-.45.25.04-.03.09-.05.13-.08.33-.19.66-.37.99-.55.13-.07.26-.14.4-.21-.36.18-.72.39-1.07.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.48,11.77c-.09.03-.17.08-.25.12.22-.13.45-.24.67-.34.35-.18.7-.34,1.05-.51-.5.23-.98.47-1.47.73Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.7,10.28h-.02c.08-.04.17-.07.25-.1.96-.39,1.94-.75,2.94-1.06-1.07.34-2.13.73-3.17,1.16Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.32,11.17c-.3-.15-.61-.29-.92-.43.15.07.3.13.45.2.25.11.49.23.74.35-.09-.04-.18-.08-.27-.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.53,11.76c-.31-.16-.62-.31-.94-.47.07.03.15.07.23.1.24.12.47.24.71.37Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.45,13.4c.16.09.32.19.48.3-.07-.04-.13-.09-.2-.12-.35-.22-.7-.44-1.06-.64-.38-.23-.76-.45-1.15-.66.43.23.86.47,1.29.72.02.02.04.03.07.04.19.12.38.23.57.36Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.25,13.89c.36.23.72.47,1.07.73-.46-.32-.92-.62-1.39-.92.11.06.21.12.32.19Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.01,15.83c.31.23.61.47.91.73-.84-.68-1.7-1.32-2.6-1.94.11.06.22.14.33.22.46.32.92.65,1.36.99Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.33,16.88c.28.23.56.46.83.72-.4-.35-.82-.7-1.24-1.04.14.09.28.21.41.32Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.41,20.95s-.03.04-.05.06c.02-.02.03-.04.05-.06Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,18.83c-.72.68-1.42,1.39-2.09,2.12.67-.73,1.37-1.44,2.09-2.12Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.84,18.52c-.11.1-.22.21-.33.31.11-.11.22-.21.33-.31Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.69,14.62c-1.72,1.18-3.34,2.49-4.85,3.9.37-.34.72-.7,1.1-1.03,1.3-1.12,2.67-2.17,4.1-3.13.86-.58,1.76-1.12,2.67-1.63-.03.02-.06.03-.09.05-.43.24-.86.5-1.28.76-.56.35-1.11.71-1.65,1.08Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.05,7.81c.71.13,1.41.29,2.11.46-.7-.17-1.4-.33-2.11-.46Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.16,8.27c.07.02.14.04.2.05-.07-.02-.13-.04-.2-.05Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.36,8.32c.65.16,1.29.34,1.93.53-.64-.19-1.28-.36-1.93-.53Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.29,8.85s.1.03.15.05c-.05-.01-.1-.03-.15-.05Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.83,12.1c.13-.07.26-.14.4-.21-.47.24-.93.5-1.39.76.33-.19.66-.37.99-.55Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.9,11.55c.35-.18.7-.34,1.05-.51-.5.23-.98.47-1.47.73.14-.08.28-.15.42-.22Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.87,9.12c-1.07.34-2.13.73-3.17,1.16.07-.04.15-.07.23-.1.96-.39,1.94-.75,2.94-1.06Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.85,10.94c.16.07.31.15.47.23-.3-.15-.61-.29-.92-.43.15.07.3.13.45.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.73,13.58c-.35-.22-.7-.44-1.06-.64.26.14.52.3.78.46.09.06.18.11.28.18Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginon);
export default __webpack_public_path__ + "static/media/loginon.e568137dce4de969a805c7fa97bf2624.svg";
export { ForwardRef as ReactComponent };